<template>
  <v-content class="pa-0 ma-0">
    <v-data-table
      v-if="messages != null"
      :items="messages"
      :headers="headers"
      disable-initial-sort
      item-key="id"
    >
      <template slot="items" slot-scope="props">
        <tr :key="props.index">
          <td class="text-xs-left">
            <a
              class="black--text"
              style="cursor: pointer"
              @click="openConversationDialog(props.item.conversation_id)"
              target="_self"
            >
              <p class="font-weight-bold pt-3 mb-1">
                {{ props.item.user_name }}:
              </p>
              <div v-html="props.item.text" />
            </a>
          </td>
          <td class="text-xs-left">
            {{ props.item.related_entities }}
          </td>
          <td class="text-xs-left">
            {{ moment(props.item.created_at).fromNow() }}
          </td>
        </tr>
      </template>

      <template slot="no-data">
        <v-layout class="text-xs-center grey--text">
          <v-flex>
            <v-icon size="16" color="grey"> priority_high </v-icon>
            <span class="ml-1">None</span>
          </v-flex>
        </v-layout>
      </template>
    </v-data-table>
  </v-content>
</template>

<script>
import moment from 'moment';

export default {
  name: 'MessageTable',
  props: {
    messages: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      moment,
      headers: [
        {
          text: 'Text (Click to open conversation)',
          align: 'left',
          value: 'text',
          width: '70%',
        },
        {
          text: 'Related Entities',
          align: 'left',
          sortable: true,
          value: 'entities',
          width: '70%',
        },
        {
          text: 'Sent',
          align: 'left',
          value: 'created_at',
          sortable: true,
          width: '30%',
        },
      ],
    };
  },
  methods: {
    openConversationDialog(conversationId) {
      this.$emit('open-specific-conversation', conversationId);
    },
  },
  watch: {},
};
</script>

<style lang="postcss" scoped></style>
